import React, { Component } from "react";
import Navbar from "./global-components/navbar";
import PageHeader from "./global-components/page-header";
import AboutV4 from "./section-components/about-v4";
import Certificate from "./section-components/certificate-v1";
import CallToActionV1 from "./section-components/call-to-action-v1";
import Footer from "./global-components/footer";
import TimelineHorizontal from "./TimelineHorizontal";
import { withAppData } from "../app/withAppData";
import { API_FILE_URL } from "../api/config";
import { fileUrl } from "../i18n/i18n";
import { clean } from "../utils/strings";
import Arge from "./section-components/arge";
import Team from "./section-components/team";

class About_v1 extends Component {
  state = {
    loading: false,
  };

  async componentDidMount() {
    // Reset scroll handled flag for new navigation
    this.scrollHandled = false;

    // Use requestAnimationFrame to ensure DOM is painted
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.handleHashNavigation();
      });
    });
  }
  waitForElement = (id, timeout = 3000) => {
    return new Promise((resolve, reject) => {
      const el = document.getElementById(id);
      if (el) return resolve(el);

      const observer = new MutationObserver(() => {
        const found = document.getElementById(id);
        if (found) {
          observer.disconnect();
          resolve(found);
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });

      setTimeout(() => {
        observer.disconnect();
        reject(new Error("Element not found in time"));
      }, timeout);
    });
  };
  handleHashNavigation = async () => {
    const hash = window.location.hash;
    if (!hash || this.scrollHandled) return;

    try {
      // Wait for DOM to be ready
      await new Promise((resolve) => {
        if (document.readyState === "complete") {
          resolve();
        } else {
          window.addEventListener("load", resolve, { once: true });
        }
      });

      // Additional wait for React rendering
      await new Promise((resolve) => setTimeout(resolve, 1000));

      const element = await this.waitForElement(hash.substring(1));
      element.scrollIntoView({ behavior: "smooth", block: "center" });
      this.scrollHandled = true;
    } catch (e) {
      console.warn("Element not found for hash:", hash);
    }
  };

  render() {
    const {
      about,
      history,
      certificate,
      rnd,
      board,
      loading,
      lang,
      pageConfig,
    } = this.props.appData;
    const teamConfig = pageConfig?.team?.settings?.translations?.[lang] || {};
    // page header title için
    const aboutTrans = about?.translations?.[lang] || {};
    const pageTitle = aboutTrans.title || "Hakkımızda";
    const breadcrumbCoverPath = clean(about?.breadcrumbCover);
    const breadcrumbCover = fileUrl(API_FILE_URL, breadcrumbCoverPath);

    const histories = Array.isArray(history?.histories)
      ? history.histories
      : [];
    // histories → timelineItems
    const timelineItems = histories.map((h) => {
      const tr = h.translations?.[lang] || {};
      const bgPath = clean(h.cover);
      const cover = fileUrl(API_FILE_URL, bgPath);
      return {
        date: h.date?.split("T")[0], // 1988-01-01
        title: tr.title || "-",
        desc: tr.content || "", // HTML olabilir
        cover: cover || "/assets/img/safkar.jpeg",
      };
    });
    // certificates
    const rawCertificates = Array.isArray(certificate?.certificates)
      ? certificate.certificates
      : [];

    // Dile göre title seç, file'ı absolut URL'e çevir
    const certificates = rawCertificates.map((c) => {
      const tr = c.translations?.[lang] || {};
      return {
        id: c.id,
        title:
          tr.title ||
          c.translations?.tr?.title ||
          c.translations?.en?.title ||
          "-",
        file: fileUrl(API_FILE_URL, clean(c.file)),
      };
    });
    // boards
    const rawBoards = Array.isArray(board?.boards) ? board.boards : [];
    // Dile göre title seç
    const boards = rawBoards.map((b) => {
      const tr = b.translations?.[lang] || {};
      return {
        id: b.id,
        name: b.name || "-",
        title:
          tr.title ||
          b.translations?.tr?.title ||
          b.translations?.en?.title ||
          "-",
      };
    });

    return (
      <div>
        <Navbar />
        <PageHeader Img={breadcrumbCover} lang={lang} headertitle={pageTitle} />
        <AboutV4 lang={lang} aboutData={about} />
        <div id="tarihce">
          <div
            className="container"
            style={{ marginTop: 40, marginBottom: 60 }}
          >
            <h2 className="mb-30">
              {lang === "tr" ? "Tarihçemiz" : "Our History"}
            </h2>
            {loading ? (
              <p>{lang === "tr" ? "Yükleniyor..." : "Loading..."}</p>
            ) : (
              <TimelineHorizontal items={timelineItems} />
            )}
          </div>
        </div>
        <div id="sertifikalar">
          <Certificate lang={lang} certificates={certificates} />
        </div>
        <div id="arge">
          <Arge lang={lang} rndData={rnd} />
        </div>
        <Team lang={lang} boards={boards} teamPageConfig={teamConfig} />
        <CallToActionV1 />
        <Footer />
      </div>
    );
  }
}

export default withAppData(About_v1);
